import api from '@pray/shared/utils/api';

import type { BrandKitResponse } from './types';

export async function getBrandKit({ artistId }: { artistId: string }): Promise<BrandKitResponse> {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/brand-kit`;
  const response = await api.executeGetRequest(url);

  return response.data.data;
}
